/**
 * Son de notification à la réception d'un message, synthé via Web Audio
 * API — comme `appels/sonnerie.ts`, aucun fichier audio à fournir ni à
 * héberger. Un seul « pop » bref à deux tons, pas de boucle.
 */

let contexte: AudioContext | null = null;
let amorcee = false;

/**
 * Débloque l'`AudioContext` dès le premier geste de l'utilisateur sur le
 * site (clic, touche), quel que soit l'écran. Sans ça, un navigateur
 * politique-autoplay laisse le contexte suspendu et la sonnerie déclenchée
 * plus tard par le WebSocket reste muette, sans jamais lever d'erreur.
 */
export function amorcerSonnerieMessage(): void {
  if (amorcee || typeof document === 'undefined') return;
  amorcee = true;
  const debloquer = (): void => {
    try {
      contexte ??= new AudioContext();
      void contexte.resume();
    } catch {
      // idem : repli sur la pop-up visuelle.
    }
  };
  document.addEventListener('pointerdown', debloquer, { once: true });
  document.addEventListener('keydown', debloquer, { once: true });
}

export function jouerSonnerieMessage(): void {
  try {
    contexte ??= new AudioContext();
    void contexte.resume();
    const maintenant = contexte.currentTime;

    [660, 880].forEach((frequence, index) => {
      const debut = maintenant + index * 0.09;
      const oscillateur = contexte!.createOscillator();
      const gain = contexte!.createGain();
      oscillateur.frequency.value = frequence;
      oscillateur.connect(gain);
      gain.connect(contexte!.destination);

      gain.gain.setValueAtTime(0.0001, debut);
      gain.gain.exponentialRampToValueAtTime(0.22, debut + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, debut + 0.16);

      oscillateur.start(debut);
      oscillateur.stop(debut + 0.18);
    });
  } catch {
    // Web Audio indisponible ou bloqué (politique d'autoplay avant tout
    // geste utilisateur) : la pop-up reste le repli visuel.
  }
}
